import { menuTextChevronClass } from '@1js/acui-button/lib/components/AppFlyoutAnchor';

const chevronRoot: string = '.' + menuTextChevronClass;
const chevronRootStyle = {
    // Fixes chevron for full-size flyout anchors with two lines of text
    [chevronRoot]: {
        display: 'inline-block',
        fontSize: '8px',
    },
};

export const defaultMlrAppButtonStyles = {
    root: {
        borderRadius: 4,
        ...chevronRootStyle,
    },
};
